import AuthenticationField from "components/onboarding/create/AuthenticationField";
import { validatePhoneNumber } from "./validators";

export const authenticationFields = [
  {
    name: "user_phone_number",
    type: "login",
    required: true,
    label: "",
    placeholder: "WhatsApp number",
    validator: validatePhoneNumber,
    formatValue: (val) => val,
    component: AuthenticationField,
  },
];
